"use client";

import { useLocale } from "next-intl";
import { useEffect } from "react";

import {
  PUSH_TOKEN_EVENT,
  syncExistingPushSubscription,
} from "@/lib/push-browser";

export function PushSubscriptionSync() {
  const locale = useLocale();

  useEffect(() => {
    function sync() {
      void syncExistingPushSubscription(locale).catch(() => {
        // A failed refresh should not interrupt the rest of the app.
      });
    }
    sync();
    window.addEventListener(PUSH_TOKEN_EVENT, sync);
    return () => window.removeEventListener(PUSH_TOKEN_EVENT, sync);
  }, [locale]);

  return null;
}
